// function that positions the logo to the bottom of the footer

function positionFooterLogos() {
  setTimeout(() => {
    const footerLogo = document.querySelector('.footer__logo');
    const footerLogoZ1 = document.getElementById('footer_logo_z_1');
    const footerLogoZ3 = document.getElementById('footer_logo_z_3');

    if (!footerLogo || !footerLogoZ1 || !footerLogoZ3) return;

    // Get the footer logo container dimensions
    const footerLogoRect = footerLogo.getBoundingClientRect();
    const footerLogoHeight = footerLogoRect.height;

    // Get the actual height of the SVG elements
    const z1Rect = footerLogoZ1.getBoundingClientRect();
    const z3Rect = footerLogoZ3.getBoundingClientRect();

    // Check if we're in animation state
    const isAnimationEnd = footerLogo.classList.contains(
      'footer__logo--animation-end'
    );

    const z1Height = z1Rect.height;
    const z3Height = z3Rect.height;

    if (isAnimationEnd) {
      // Animation state: Z1 and Z3 move up less, allowing footer logo to catch up
      // Position them so footer logo overlaps them
      const halfZ1Height = z1Height / 2;
      const halfZ3Height = z3Height / 2;

      footerLogoZ1.style.top = `${-halfZ1Height}px`;
      footerLogoZ3.style.top = `${-halfZ3Height}px`;
    } else {
      // Initial state: Z1 and Z3 positioned higher up
      // Footer logo will "catch up" to them during animation
      // desktop
      if (window.innerWidth > 750) {
        footerLogoZ1.style.top = `${-z1Height * 0.85}px`;
        footerLogoZ3.style.top = `${-z3Height * 0.85}px`;
      } else {
        footerLogoZ1.style.top = `${-z1Height * 1.25}px`;
        footerLogoZ3.style.top = `${-z3Height * 1.25}px`;
      }
    }
  }, 1000);
}

// calculate height from  top position of footer to  window bottom and set it on footer element
function setFooterHeight() {
  const footer = document.querySelector('footer');
  const footerMarginTop =
    parseInt(window.getComputedStyle(footer).marginTop, 10) * 2;
  const footerGreyBg = document.querySelector('.footer__bg-grey');
  const footerBgGreyBeforeMargin = window
    .getComputedStyle(footerGreyBg, '::before')
    .getPropertyValue('bottom');

  const footerGreyBgHeight = footerGreyBg.getBoundingClientRect().height;
  const footerHeight =
    footerGreyBgHeight +
    footerMarginTop -
    parseInt(footerBgGreyBeforeMargin, 10);

  // only set on desktop
  if (window.innerWidth > 750) {
    footer.style.height = `${footerHeight}px`;
  }
}

function addFooterAnimation() {
  let footerLogo = document.querySelector('.footer__logo');
  let footerContentTop = document.querySelector('.footer__content-top');
  let footerBgGrey = document.querySelector('.footer__bg-grey');
  let footerContentOverflow = document.querySelector(
    '.footer__content-overflow'
  );

  footerLogo.classList.add('footer__logo--animation-end');
  footerContentTop.classList.add('footer__content-top--animation-end');
  footerBgGrey.classList.add('footer__bg-grey--animation-end');
  footerContentOverflow.classList.add(
    'footer__content-overflow--animation-end'
  );

  // Recalculate positions after animation state change
  // positionFooterLogos();
}

function removeFooterAnimation() {
  let footerLogo = document.querySelector('.footer__logo');
  let footerContentTop = document.querySelector('.footer__content-top');
  let footerBgGrey = document.querySelector('.footer__bg-grey');
  let footerContentOverflow = document.querySelector(
    '.footer__content-overflow'
  );

  footerLogo.classList.remove('footer__logo--animation-end');
  footerContentTop.classList.remove('footer__content-top--animation-end');
  footerBgGrey.classList.remove('footer__bg-grey--animation-end');
  footerContentOverflow.classList.remove(
    'footer__content-overflow--animation-end'
  );

  // Recalculate positions after animation state change
  // positionFooterLogos();
}

// Scroll in animation logic
function onFooterIntersection(elements, observer) {
  elements.forEach((element) => {
    const ratio = element.intersectionRatio;

    if (ratio == 0) {
      removeFooterAnimation();
    } else {
      if (window.innerWidth < 750 && ratio > 0.85) {
        addFooterAnimation();
      } else {
        addFooterAnimation();
      }
    }
  });
}

function initializeScrollFooterAnimationTrigger() {
  const animationTriggerElements = [document.querySelector('footer')];

  function getRootMargin() {
    return window.innerWidth < 750 ? '-45% 0px 0px 0px' : '0px 0px 0px 0px';
  }

  const observer = new IntersectionObserver(onFooterIntersection, {
    rootMargin: getRootMargin(),
    threshold: [0, 0.85, 0.85, 1],
  });

  // Update rootMargin on window resize
  window.addEventListener('resize', () => {
    observer.disconnect();
    observer.rootMargin = getRootMargin();
    animationTriggerElements.forEach((element) => observer.observe(element));
  });

  animationTriggerElements.forEach((element) => observer.observe(element));
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollFooterAnimationTrigger();
  // Initial positioning
  //positionFooterLogos();
  setFooterHeight();
});

// Recalculate positions on window resize
window.addEventListener('resize', () => {
  //positionFooterLogos();
  setFooterHeight();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) =>
    initializeScrollFooterAnimationTrigger(event.target, true)
  );
  document.addEventListener('shopify:section:reorder', () =>
    initializeScrollFooterAnimationTrigger(document, true)
  );
}
